import { render } from "./StandardsSection.vue?vue&type=template&id=eb239396"
import script from "./StandardsSection.vue?vue&type=script&lang=js"
export * from "./StandardsSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__